;(function($) {
    'use strict';

    $.fn.scrollOrder = function () {
        const $self = $(this);
        // TODO: доделать плагин, проблема с вычислением нижней точки
        // const setTotalPosition = () => {
        //     if (SVK.checkBreakpoint() === 'desktop') {
        //         const $content = $self.find('.eshop-order__right-wrapper');
        //         const rectContainer = $self.offset();
        //         const rectContent = $content.offset();
        //         const containerHeight = $self.outerHeight();
        //         const contentHeight = $content.outerHeight();
        //         const scroll = window.pageYOffset;
        //         const deltaTop = rectContainer.top - scroll;
        //
        //         if (deltaTop <= 240) {
        //             $content.addClass('fixed');
        //         } else {
        //             $content.removeClass('fixed');
        //         }
        //     }
        // };
        //
        // $(window).on('scroll resize load', setTotalPosition);
        // setTotalPosition();
        //
        // return $self;
    };

})(jQuery);
